define([
	"dojo/_base/declare",
	"csi/gallery/New",
	"./_NewStyleMixin"
], function(declare, New, _NewStyleMixin) {

	return declare([New, _NewStyleMixin], {
		/**
		 * @override
		 * resize view on "save and new" to accommodate newly created style card
		 */
		postProcessSuccess: function() {
			this.inherited(arguments);
			if (this.m_proxy?.m_action?.m_bRepeat) {
				this.widget.resize();
			}
		}
		
	});
});